import React from 'react'
import {Distance, Elevation} from 'common/units'
import styles from './RouteWidget.scss'
import {SimpleMap} from 'common/SimpleMap'
import cx from 'classnames'
import {Icon} from 'common/Icon'
import {MapSettings} from 'common/Map'
import {MetricUnitsContext} from 'common/units/MetricUnitsContext'
import {apiv3} from 'lib/apiv3'

export class RouteWidget extends React.PureComponent {
  state = {
    bulkExportPending: false,
    selectedRoute: 0, // -1 means all routes
    mapSettings: MapSettings({
      scrollWheelZoom: false
    })
  }

  onToggleSetting = (setting) => {
    const {mapSettings} = this.state
    this.setState({mapSettings: mapSettings.set(setting, !mapSettings.get(setting))})
  }

  onGetExport = () => {
    const {experience, appCode} = this.props
    this.setState({bulkExportPending: true})
    apiv3.experiences.routesExport(experience.id, {appCode: appCode.code})
      .then(({exportUrl}) => {
        this.setState({bulkExportPending: false})
        window.location.href = exportUrl
      })
  }

  render () {
    const {routeTuples, appCode, allowDownload} = this.props
    const routes = routeTuples.map(([route, _]) => route)
    const {selectedRoute, mapSettings} = this.state

    const routeIdsToDisplay = selectedRoute === -1
      ? routes.map(r => r.id).toArray()
      : (routes.size > 0 ? [routes.get(selectedRoute).id] : [])

    const privacyCodes = routes.reduce((obj, r) => { obj[r.id] = r.privacyCode; return obj }, {})

    return (
      <MetricUnitsContext.Provider value={mapSettings.metricUnits}>
        <div className={styles.RouteWidget}>
          <div className={styles.left}>
            <div className={styles.routeList}>
              {routeTuples.map(([r, er], i) => <div key={r.id} className={cx(styles.routeListItem, selectedRoute === i && styles.selected)} onClick={() => this.setState({selectedRoute: i})}>
                <h3>{r.name}</h3>
                <div className={styles.routeDetails}>
                  <span>{r.locality}, {r.administrativeArea}</span>
                  <span><Distance short value={r.distance} /></span>
                  {/* why are we showing a plus here when we no longer show a plus for ele gain anywhere else? */}
                  <span>+<Elevation short value={r.elevationGain} /></span>
                  {allowDownload && <a href={`/experience_routes/${er.id}.tcx?app_code=${appCode.code}`} className={styles.dlIcon}><Icon i='md-download' size={20} /></a>}
                </div>
              </div>)}
            </div>
            <div className={styles.listActions}>
              <a onClick={() => this.setState({selectedRoute: -1})}>Show All On Map</a>
              {allowDownload && <a onClick={this.onGetExport}>Export All</a>}
            </div>
          </div>
          <div className={styles.right}>
            <SimpleMap
              routeIds={routeIdsToDisplay}
              privacyCodes={privacyCodes}
              experimental
              showToolbar
              mapSettings={mapSettings}
              onToggleSetting={this.onToggleSetting}
              height='535px'
              defaultOverlay='rwgps'
              sampleGraph
              metricUnits={mapSettings.metricUnits} />
          </div>
        </div>
      </MetricUnitsContext.Provider>
    )
  }
}
